<template>
  <section id="hero" class="container-fluid" style="z-index: 1; position: relative;">
    <div class="container-fluid px-lg-4 pb-5 mb-5 mx-0 d-flex justify-content-center">
      <div id="heroCarousel" class="carousel mx-0 slide w-100" data-bs-ride="carousel" style="position: relative; max-width: 1300px;">
        <!-- Slides -->
        <div v-if="bannersLoading" class="carousel-inner">
          <div class="carousel-item active">
            <div class="d-flex justify-content-center align-items-center" style="height: 300px;">
              <div class="spinner-border text-light" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
            </div>
          </div>
        </div>
        
        <div v-else class="carousel-inner">
          <div v-for="(banner, index) in banners" :key="banner.id" :class="['carousel-item', index === 0 ? 'active' : '']">
            <a :href="banner.url_to || '#'" :target="banner.url_to ? '_blank' : '_self'" class="p-0">
              <img 
                :src="isMobile && banner.mobile_image_url ? banner.mobile_image_url : banner.image_url" 
                :alt="banner.title || `Banner ${index + 1}`" 
                class="img-fluid p-lg-4 p-0 carousel-banner-img"
              >
            </a>
          </div>
        </div>
        
        <!-- Indicadores circulares -->
        <div class="carousel-indicators-wrapper">
          <div class="carousel-indicators mb-lg-0 mb-0 pt-lg-3 pt-5">
            <button 
              v-for="(banner, i) in banners" 
              :key="i" 
              type="button" 
              data-bs-target="#heroCarousel" 
              :data-bs-slide-to="i" 
              :class="{ active: i === 0 }" 
              :aria-current="i === 0 ? 'true' : 'false'"
              :aria-label="'Slide ' + (i + 1)"
            ></button>
          </div>
        </div>
        </div>
    </div>
  </section>
  <section id="aboutUs" style="margin-top: -7.5rem; z-index: 2; position: relative;">
    <div class="position-relative">
      <!-- Fondo responsivo -->
      <img src="@/assets/images/QUIENES-SOMOS.svg" alt="¿Quiénes somos?" class="img-fluid w-100">
      
      <!-- Contenido superpuesto -->
      <div class="container-fluid aboutUs-content d-flex justify-content-center px-lg-5 p-3 pb-4">
        <div class="row align-items-center" style="max-width: 1300px;">
          <!-- Logo a la izquierda en desktop, arriba en móvil -->
          <div class="col-lg-5 mb-1 mb-lg-0 pe-4 ps-0 text-center text-lg-end">
            <img src="@/assets/images/KAME-SEEDS-LOGO-LETTERING.svg" alt="KAME SEEDS" style="max-height: 350px;" class="about-us-logo">
          </div>
          <!-- Texto a la derecha en desktop, abajo en móvil -->
          <div class="col-lg-7 desktop-border px-2 ps-lg-4">
            <div class="about-us-text">
              <p class="about-us-paragraph fw-light fs-4 dinn-font">Durante más de una década, nos hemos enfocado en seleccionar las variedades de cannabis que mejor se adapten a nuestras necesidades, buscando el cruce más óptimo entre terpenos intensos, resistencia a plagas y hongos, rendimiento y concentración de resina.</p>
              <p class="about-us-paragraph fw-light fs-4 dinn-font">A través de la combinación de genéticas únicas, hemos logrado crear semillas argentinas de gran calidad. Estamos inscriptos como criadores en el INASE, cumpliendo con todas las regulaciones del cannabis en el país.</p>
             </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="highlightedGenetics" style="margin-top:-10.5rem;position: relative;">
    <div class="highlighted-background px-5">
      <div class="container mt-5 pt-5 position-relative" style="z-index: 2;">
        <div class="row" style="margin-top: 80px;">
          <!-- Título amarillo: componente compartido (mismo que Galería y Blog) -->
          <TitleYellow text="GENÉTICAS DESTACADAS" />
          <div v-if="highlightedProductsLoading" class="col-12 text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Cargando...</span>
            </div>
          </div>
          <div v-else-if="highlightedProducts.length === 0" class="col-12 text-center">
            <p>No hay productos destacados disponibles</p>
          </div>
          <div v-else class="col-md-4 mb-4 d-flex justify-content-around" v-for="product in highlightedProducts" :key="product.id">
            <ProductCard :product="product" style="max-width: 350px;" :showFirstImage="true" :blur-background="false" :image-only="true" />
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="loader-container" v-if="loadingPage">
    <div class="loader"></div>
  </div>
</template>

<script>
import { getProducts, getProductsOnSale, getHighlightedProducts } from "@/services/products";
import { getBrands } from "@/services/brands";
import { getBanners } from "@/services/banners";
import ProductCard from "@/components/ProductCard.vue";
import TitleYellow from "@/components/TitleYellow.vue";

export default {
  name: "PageHome",
  components: {
    ProductCard,
    TitleYellow,
  },
  data() {
    return {
      products: [],
      productsOnSale: [],
      highlightedProducts: [],
      brandsList: [],
      isLoading: false,
      productsLoading: false,
      highlightedProductsLoading: false,
      loadingPage: true,
      banners: [],
      bannersLoading: false,
      isMobile: false
    };
  },
  watch: {
    // Re-render when screen size changes between mobile and desktop
    isMobile(newVal) {
      console.log("Screen size changed, isMobile:", newVal);
      // Reload banners when screen size crosses the mobile/desktop threshold
      this.loadBanners();
    }
  },
  methods: {
    async loadProducts() {
      try {
        this.isLoading = true;
        const data = await getProducts();
        // Access the results property which contains the array of products
        this.products = data.results ? data.results.slice(0, 8) : [];
      } catch (error) {
        console.error('Error loading products:', error);
      } finally {
        this.isLoading = false;
        this.productsLoading = false;
      }
    },
    async loadProductsOnSale() {
      try {
        this.isLoading = true;
        const response = await getProductsOnSale();
        // Acceder a results que contiene el array de productos
        this.productsOnSale = response.results ? response.results.slice(0, 8) : [];
      } catch (error) {
        console.error('Error loading products on sale:', error);
        this.productsOnSale = []; // Asignar array vacío en caso de error
      } finally {
        this.isLoading = false;
        this.productsLoading = false;
      }
    },
    async loadBrands() {
      try {
        const brands = await getBrands();
        this.brandsList = brands;
      } catch (error) {
        console.error('Error loading brands:', error);
        this.brandsList = []; // Array vacío en caso de error
      }
    },
    async loadHighlightedProducts() {
      try {
        this.highlightedProductsLoading = true;
        const response = await getHighlightedProducts(3); // Limit to 3 products
        this.highlightedProducts = response.results || [];
      } catch (error) {
        console.error('Error loading highlighted products:', error);
        this.highlightedProducts = []; // Array vacío en caso de error
      } finally {
        this.highlightedProductsLoading = false;
      }
    },
    
    async loadBanners() {
      try {
        this.bannersLoading = true;
        
        // Force a fresh load when the page loads initially to ensure we get the right images for this device
        const response = await getBanners({ 
          position: 'carousel', 
          active: true, 
          forceRefresh: true // Force fresh data load
        });
        console.log(`Banners cargados para ${this.isMobile ? 'mobile' : 'desktop'}:`, response);
        
        // Handle both array format and object with results property
        const bannersData = Array.isArray(response) ? response : (response.results || []);
        
        // Usar banners con imagen principal; la móvil es opcional (fallback a desktop)
        this.banners = bannersData.filter(banner => banner.image_url);
        
        console.log('Banners procesados:', this.banners.map(b => ({
          id: b.id, 
          has_desktop: !!b.image_url, 
          has_mobile: !!b.mobile_image_url
        })));
        
        // Si no hay banners disponibles, usamos banners de respaldo
        if (!this.banners.length) {
          console.log('No se encontraron banners en el backend, usando banners por defecto');
          this.banners = [
            {
              id: 1,
              image_url: require('@/assets/images/banners/BANNER-9001.svg'),
              mobile_image_url: require('@/assets/images/banners/BANNER-9001.svg'),
              title: 'Banner 1'
            },
            {
              id: 2,
              image_url: require('@/assets/images/banners/BANNER-9001.svg'),
              mobile_image_url: require('@/assets/images/banners/BANNER-9001.svg'),
              title: 'Banner 2'
            },
            {
              id: 3,
              image_url: require('@/assets/images/banners/BANNER-9001.svg'),
              mobile_image_url: require('@/assets/images/banners/BANNER-9001.svg'),
              title: 'Banner 3'
            }
          ];
        }
      } catch (error) {
        console.error('Error loading banners:', error);
        // Usar banners de respaldo en caso de error
        this.banners = [
          {
            id: 1,
            image_url: require('@/assets/images/banners/BANNER-9001.svg'),
            mobile_image_url: require('@/assets/images/banners/BANNER-9001.svg'),
            title: 'Banner 1'
          },
          {
            id: 2,
            image_url: require('@/assets/images/banners/BANNER-9001.svg'),
            mobile_image_url: require('@/assets/images/banners/BANNER-9001.svg'),
            title: 'Banner 2'
          },
          {
            id: 3,
            image_url: require('@/assets/images/banners/BANNER-9001.svg'),
            mobile_image_url: require('@/assets/images/banners/BANNER-9001.svg'),
            title: 'Banner 3'
          }
        ];
      } finally {
        this.bannersLoading = false;
      }
    },
    
    checkScreenSize() {
      // Consider tablets as mobile for image display purposes (up to 992px)
      const newIsMobile = window.innerWidth < 992;
      if (this.isMobile !== newIsMobile) {
        console.log(`Screen size changed: ${window.innerWidth}px - Using ${newIsMobile ? 'mobile' : 'desktop'} images`);
        this.isMobile = newIsMobile;
      }
    },
  },
  async mounted() {
    // Inicializar detector de tamaño de pantalla
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
    
    setTimeout(() => {
      this.loadingPage = false;
    }, 500);
    
    await Promise.all([
      this.loadHighlightedProducts(),
      this.loadBanners()
    ]);
  },
  
  beforeUnmount() {
    // Limpiar el event listener cuando el componente se destruye
    window.removeEventListener('resize', this.checkScreenSize);
  },
};
</script>

<style scoped>
#hero {
  background: url('@/assets/images/fondos/fondo-1.svg') no-repeat;
  background-size: cover;
  height: 104vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
#hero img {
  object-fit: contain;
  width: 100%;
  display: block;
}
.carousel-inner {
  max-height: 80vh;
}

@media (max-width: 768px) {
  #hero {
    height: 100vh; /* Ajusta la altura para pantallas pequeñas */
  }
  #hero img {
    height: auto;
    max-height: 100%;
    width: 100%;
  }
}

#aboutUs {
  transition: transform 0.3s ease;
  z-index: 2;
}


.aboutUs-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.about-us-logo {
  max-width: 100%;
  height: auto;
}

.about-us-text {
  color: white;
  padding: 1rem 0;
}

.about-us-paragraph {
  margin-bottom: 1rem;
  font-size: 1rem;
  line-height: 1.5;
}

.desktop-border {
  border-left: 4px solid white; 
  padding-left: 1rem;
}

/* Media queries para la sección About Us */
@media (max-width: 991.98px) {
  #aboutUs {
    margin-top: -10rem !important; /* Ajustar margen superior para tablets */
  }
  #highlightedGenetics {
    margin-top: -15rem !important; /* Ajustar margen superior para tablets */
  }

  .highlighted-background {margin-top: -14rem !important;}
  .aboutUs-content {
    position: absolute; /* Mantener posición absoluta para superponerse al fondo */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 1.5rem 1rem;
    width: 90%; /* Ajustar ancho del contenido para que no se salga */
    max-height: 85%; /* Evitar que el contenido se salga por debajo */
    overflow-y: auto; /* Permitir scroll si el contenido es demasiado largo */
  }
  
  .about-us-logo {
    max-width: 90%; /* Reducir tamaño en móvil */
    margin-bottom: 1rem;
  }
  
  #aboutUs img.img-fluid.w-100 {
    min-height: 1350px; /* Aumentamos altura en tablets para más espacio */
    object-fit: cover;
  }
  
  /* Ajustes para el texto en móvil */
  .about-us-paragraph.fs-4 {
    font-size: 1.4rem !important; /* Reducir tamaño de fuente en móvil */
    margin-bottom: 0.5rem; /* Menos espacio entre párrafos */
  }
  
  /* Eliminar el borde izquierdo en móvil y añadir espacio entre logo y texto */
  #aboutUs .col-lg-7 {
    border-left: none !important;
    padding-left: 0 !important;
  }
  
  /* Reorganizar como columna en móvil */
  #aboutUs .row {
    flex-direction: column;
  }
}

/* Ajustes específicos para smartphones */
@media (max-width: 575.98px) {
  
  #highlightedGenetics {
    margin-top: -10rem !important; /* Ajustar margen superior para smartphones */
  }
  .about-us-logo {
    max-width: 90%; /* Logo aún más pequeño en smartphones */
  }
  
  .aboutUs-content {
    width: 90%;
    top: 55%; /* Ajustar posición vertical para centrar mejor en el fondo más alto */
  }
  
  
  .about-us-text {
    padding: 0.5rem;
  }
}

#highlightedGenetics {
  color: white;
}

.highlighted-background {
  background: url('@/assets/images/fondos/fondo-2.svg') no-repeat;
  background-size: cover;
  background-position: top;
  position: relative;
  width: 100%;
  min-height: 800px;
}

#hightlightedGenetics h2 {
  font-weight: 700;
  font-size: 2rem;
  color: #ffffff;
  margin-bottom: 1.5rem;
  text-shadow: 0 0 10px rgba(0,0,0,0.5);
}

/* Estilos para los indicadores circulares del carrusel */
.carousel-indicators-wrapper {
  position: relative;
  z-index: 9999;
}

.carousel-indicators {
  bottom: 10px;
  position: relative;
  z-index: 9999;
}


.carousel-indicators button {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 0 5px;
  opacity: 0.7;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  position: relative;
  z-index: 9999;
}

.carousel-indicators button.active {
  background-color: white;
  width: 9px;
  height: 9px;
  opacity: 1;
  border: 2px solid rgba(255, 255, 255, 0.8);
  transform: scale(1.1);
}

/* Asegurarnos que el carrusel ocupa todo el ancho disponible */
#heroCarousel {
  width: 100%;
  position: relative;
  margin: 0 auto;
}

/* Añadir transición suave entre slides */
.carousel-item {
  transition: transform .6s ease-in-out;
  text-align: center;
  min-height: 250px;
  min-height: 600px; /* Altura fija para el carrusel */
  width: 100%;
}

.carousel-item img.carousel-banner-img {
  width: 500px;
  object-fit: cover;
  display: inline-block;
}

@media (max-width: 992px) {
  .carousel-item {
    height: auto;
    min-height: 350px;
  }
  
  .carousel-item img.carousel-banner-img {
    width: 100%;
    height: auto;
    max-width: 1080px;
    max-height: 1320px;
    aspect-ratio: 1080 / 1420;
  }
}


</style>
